import axiosDmsInstance from './axiosDmsInstance';
import { handleApiError } from '../../common/util';
import { IEmailMessage } from '../../models/dms/email.model';

export const sendEmail = async (emailMessage: IEmailMessage) => {
  try {
    const url = `/api/utility/v1/email`;
    let params = {} as any;

    const response = await axiosDmsInstance.post(`${url}`, emailMessage, {
      params
    });

    return response.data;
  } catch (err: any) {
    return handleApiError('sendEmail', err);
  }
};